import {useMatch} from '@github-ui/react-router'
import {
  ChangesRoutePath,
  ChecksRoutePath,
  CommitsRoutePath,
  FilesRoutePath,
  FindingsRoutePath,
  WalkthroughRoutePath,
} from '../routes/route-paths'
import {useIsOverviewEnabled} from './use-feature-state'

export type PullRequestActiveRoute =
  | 'overview'
  | 'conversation'
  | 'files_changed'
  | 'commits'
  | 'checks'
  | 'findings'
  | 'walkthrough'

/** Returns which pull request route is currently active. */
export function useActiveRoute(): PullRequestActiveRoute {
  const isFiles = useMatch(`${FilesRoutePath}/*`) !== null // will only trigger from React partial in Rails Files Changed
  const isChanges = useMatch(`${ChangesRoutePath}/*`) !== null
  const isCommits = useMatch(`${CommitsRoutePath}/*`) !== null
  const isChecks = useMatch(`${ChecksRoutePath}/*`) !== null
  const isFindings = useMatch(`${FindingsRoutePath}/*`) !== null
  const isWalkthrough = useMatch(`${WalkthroughRoutePath}/*`) !== null

  const overviewIsIndexRoute = useIsOverviewEnabled()

  if (isFiles || isChanges) return 'files_changed'
  if (isCommits) return 'commits'
  if (isChecks) return 'checks'
  if (isFindings) return 'findings'
  if (isWalkthrough) return 'walkthrough'

  if (overviewIsIndexRoute) return 'overview'
  return 'conversation'
}
